export enum LivenessStepsEnum {
    PROCESS = 'process',
    FINISH = 'finish',
}
